import React, { useEffect, useRef, useState } from "react";
import { Box, ThemeProvider, createTheme } from "@mui/material";
import Tooltip from "./Tooltip";

export interface OverflowTooltipProps {
  text?: string;
  className?: string;
  color?: string;
  wrap?: boolean;
}

const OverflowTooltip = ({ text, className, wrap = false, ...props }: OverflowTooltipProps) => {
  const [isOverflow, setIsOverflow] = useState(false);
  const elementRef = useRef() as any;

  const checkOverflow = () => {
    const compare = elementRef.current?.scrollWidth > elementRef.current?.clientWidth;
    setIsOverflow(compare);
  };

  useEffect(() => {
    checkOverflow();
    window.addEventListener('resize', checkOverflow);
    return () => window.removeEventListener('resize', checkOverflow);
  }, []);

  const theme = createTheme({});

  return (
    <ThemeProvider theme={theme}>
      <Tooltip title={text} disableHoverListener={!isOverflow}>
        <Box
          ref={elementRef}
          className={className}
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: wrap ? "wrap" : "nowrap"
          }}
          {...props}>
          {text}
        </Box>
      </Tooltip>
    </ThemeProvider>
  );
};

export default OverflowTooltip;